var map = {
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"views-dashboard-dashboard-module"
	],
	"./views/feedback/feedback.module": [
		"./src/app/views/feedback/feedback.module.ts",
		"views-feedback-feedback-module"
	],
	"./views/projects/base.module": [
		"./src/app/views/projects/base.module.ts",
		"default~views-projects-base-module~views-users-users-base-module",
		"views-projects-base-module"
	],
	"./views/users/users-base.module": [
		"./src/app/views/users/users-base.module.ts",
		"default~views-projects-base-module~views-users-users-base-module",
		"views-users-users-base-module"
	],
	"./views/version/version.module": [
		"./src/app/views/version/version.module.ts",
		"views-version-version-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;